import type * as schemas from '../components/schemas';

/**
 * 获取短剧信息
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/outer/activities/tube/getTubes
 * * __tags__: TubeOuterController
 */
export namespace tubeOuterControllerGetTubes {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/outer/activities/tube/getTubes';
  export const getPath = ({} : {}) => '/rest/wd/growth/outer/activities/tube/getTubes';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultMapStringTubePageCardVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.TubeParam,
  }
  
}
/**
 * 获取短剧渠道包信息
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/outer/activities/tube/getMeta
 * * __tags__: TubeOuterController
 */
export namespace tubeOuterControllerGetMeta {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/outer/activities/tube/getMeta';
  export const getPath = ({} : {}) => '/rest/wd/growth/outer/activities/tube/getMeta';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultTubeMetaVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.MetaParam,
  }
  
}
/**
 * 获取头图短剧信息
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/outer/activities/tube/getHeadTube
 * * __tags__: TubeOuterController
 */
export namespace tubeOuterControllerGetHeadTube {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/outer/activities/tube/getHeadTube';
  export const getPath = ({} : {}) => '/rest/wd/growth/outer/activities/tube/getHeadTube';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultTubeInfoVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.TubeParam,
  }
  
}
/**
 * 站外查询商品列表接口
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/outer/activities/shelf/listShelfCommodityInfo
 * * __tags__: ShelfCommodityInnerController
 */
export namespace shelfCommodityOuterControllerListShelfCommodityInfo {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/outer/activities/shelf/listShelfCommodityInfo';
  export const getPath = ({} : {}) => '/rest/wd/growth/outer/activities/shelf/listShelfCommodityInfo';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultShelfCommodityInfoVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.ShelfCommodityParam,
  }
  
}
/**
 * 获取短剧信息
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/inner/activities/tube/getTubes
 * * __tags__: TubeInnerController
 */
export namespace tubeInnerControllerGetTubes {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/inner/activities/tube/getTubes';
  export const getPath = ({} : {}) => '/rest/wd/growth/inner/activities/tube/getTubes';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultMapStringTubePageCardVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.TubeParam,
  }
  
}
/**
 * 获取头图短剧信息
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/inner/activities/tube/getHeadTube
 * * __tags__: TubeInnerController
 */
export namespace tubeInnerControllerGetHeadTube {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/inner/activities/tube/getHeadTube';
  export const getPath = ({} : {}) => '/rest/wd/growth/inner/activities/tube/getHeadTube';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultTubeInfoVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.TubeParam,
  }
  
}
/**
 * 站内查询商品列表接口
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/inner/activities/shelf/listShelfCommodityInfo
 * * __tags__: ShelfCommodityOuterController
 */
export namespace shelfCommodityInnerControllerListShelfCommodityInfo {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/inner/activities/shelf/listShelfCommodityInfo';
  export const getPath = ({} : {}) => '/rest/wd/growth/inner/activities/shelf/listShelfCommodityInfo';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultShelfCommodityInfoVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.ShelfCommodityParam,
  }
  
}
/**
 * 站外查询敢比价商品列表接口
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/outer/listCompareItemInfo
 * * __tags__: CommodityController
 */
export namespace commodityOuterControllerListCompareItemInfo {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/outer/listCompareItemInfo';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/outer/listCompareItemInfo';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultCompareCommodityInfoVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.CommodityBaseParam,
  }
  
}
/**
 * 站外查询商品列表接口
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/outer/listCommodityInfo
 * * __tags__: CommodityController
 */
export namespace commodityOuterControllerListCommodityInfo {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/outer/listCommodityInfo';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/outer/listCommodityInfo';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultCommodityInfoVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.CommodityParam,
  }
  
}
/**
 * 获取站外活动页面基础配置，ruleLinkUrl-规则页，imageUrl-头图，backgroundColor-背景色，activityName-活动名称
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/outer/getPageConfiguration
 * * __tags__: CommodityController
 */
export namespace commodityOuterControllerGetPageConfiguration {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/outer/getPageConfiguration';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/outer/getPageConfiguration';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultMapStringObject,
    },
  }
  export interface RequestBody {
    "application/json": schemas.PageConfigurationParam,
  }
  
}
/**
 * 抢购接口
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/inner/snapUpItem
 * * __tags__: CommodityController
 */
export namespace commodityInnerControllerSnapUpItem {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/inner/snapUpItem';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/inner/snapUpItem';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultSnapVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.SnapParam,
  }
  
}
/**
 * 多优惠券抢购接口
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/inner/snapMultiCoupon
 * * __tags__: CommodityController
 */
export namespace commodityInnerControllerSnapMultiCoupon {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/inner/snapMultiCoupon';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/inner/snapMultiCoupon';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultSnapVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.SnapParam,
  }
  
}
/**
 * ABTest策略接口，1-默认，2-无挽留弹窗
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/inner/routineTestStrategy
 * * __tags__: CommodityController
 */
export namespace commodityInnerControllerRoutineStrategy {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/inner/routineTestStrategy';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/inner/routineTestStrategy';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultInteger,
    },
  }
  export interface RequestBody {
    
  }
  
}
/**
 * 站内查询敢比价商品列表接口
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/inner/listCompareItemInfo
 * * __tags__: CommodityController
 */
export namespace commodityInnerControllerListCompareItemInfo {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/inner/listCompareItemInfo';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/inner/listCompareItemInfo';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultCompareCommodityInfoVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.CommodityBaseParam,
  }
  
}
/**
 * 站内查询商品列表接口
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/inner/listCommodityInfo
 * * __tags__: CommodityController
 */
export namespace commodityInnerControllerListCommodityInfo {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/inner/listCommodityInfo';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/inner/listCommodityInfo';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultCommodityInfoVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.CommodityParam,
  }
  
}
/**
 * 是否领券接口
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/inner/isReceiveCoupon
 * * __tags__: CommodityController
 */
export namespace commodityInnerControllerIsReceiveCoupon {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/inner/isReceiveCoupon';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/inner/isReceiveCoupon';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultReceiveVo,
    },
  }
  export interface RequestBody {
    "application/json": schemas.SnapParam,
  }
  
}
/**
 * 获取站内活动页面基础配置，ruleLinkUrl-规则页，imageUrl-头图，backgroundColor-背景色，activityName-活动名称
 * 
 * * __method__: POST
 * * __path__: /rest/wd/growth/activities/commodity/inner/getPageConfiguration
 * * __tags__: CommodityController
 */
export namespace commodityInnerControllerGetPageConfiguration {
  
  export const method = 'post';
  export const path = '/rest/wd/growth/activities/commodity/inner/getPageConfiguration';
  export const getPath = ({} : {}) => '/rest/wd/growth/activities/commodity/inner/getPageConfiguration';
  export const parameterNames = {"path":[],"query":[],"header":[],"cookie":[]} as const
  
  export type Parameter = {};
  export interface Response {
    "200": {
      "*/*": schemas.ApiResultMapStringObject,
    },
  }
  export interface RequestBody {
    "application/json": schemas.PageConfigurationParam,
  }
  
}